import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import I18n from "i18next";
import { recoverPassword, forgotPasswordSubmit, logIn } from "store/slices/authPages";
import ForgotPassword from "components/auth/ForgotPassword";
import CreatePassword from "components/auth/CreatePassword";
import findError from "utils/findError";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState(null);
  const [emailSent, setEmailSent] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function handleLogin() {
    navigate("/sign-in");
  }

  async function handleForgotSubmit({ email }) {
    setEmail(email);
    try {
      await dispatch(recoverPassword(email));
      setShowNotification({
        type: "success",
        message: I18n.t("authPages.otpSentAlert")
      });
      setEmailSent(true);
    } catch (err) {
      setShowNotification({
        type: "error",
        message: findError(err.name)
      });
    }
  }
  const handlePasswordSubmit = async ({ code, password }) => {
    try {
      const data = {
        email,
        code,
        password
      };
      await dispatch(forgotPasswordSubmit(data));
      await dispatch(logIn(email, password));
    } catch (error) {
      setShowNotification({ type: "error", message: findError(error.name) });
    }
  };

  async function handleResend() {
    setShowNotification(false);
    try {
      await dispatch(recoverPassword(email));
      setShowNotification({
        type: "success",
        message: I18n.t("authPages.otpSentAlert")
      });
    } catch (error) {
      setShowNotification({
        type: "error",
        message: findError(error.name)
      });
    }
  }

  function handleAlertClose() {
    setShowNotification({
      type: "",
      message: ""
    });
  }

  function handleSignIn() {
    navigate("/sign-in");
  }

  return (
    <>
      {!emailSent && (
        <ForgotPassword
          showNotification={showNotification}
          onAlertClose={handleAlertClose}
          onLogin={handleLogin}
          onSubmit={handleForgotSubmit}
          onResend={handleResend}
        />
      )}
      {emailSent && (
        <CreatePassword
          showNotification={showNotification}
          onSignIn={handleSignIn}
          onSubmit={handlePasswordSubmit}
          onResend={handleResend}
          onAlertClose={handleAlertClose}
        />
      )}
    </>
  );
}
